var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '@shapeable/utils';
var cls = classNames('icon-text-value');
import { breakpoints, theme } from '@shapeable/theme';
import { PersonIcon } from '@shapeable/icons';
import { CellHeader } from './cell-header';
import { Content } from './content';
import { Icon } from './icon';
import { useLang } from '../hooks/use-lang';
import { useLink } from '../hooks/use-link';
export var IconTextValueDefaultProps = {
  color: '#FFFFFF',
  iconSize: 16,
  useIcon: true,
  reverse: false
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    gap: ", ";\n\n    ", "\n\n    ", "\n\n    ", "\n  "], ["\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    gap: ", ";\n\n    ", "\n\n    ", "\n\n    ", "\n  "])), theme.UNIT(3), function (_a) {
    var reverse = _a.reverse;
    return reverse && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      flex-direction: row-reverse;\n      justify-content: flex-end;\n      gap: ", ";\n    "], ["\n      flex-direction: row-reverse;\n      justify-content: flex-end;\n      gap: ", ";\n    "])), theme.UNIT(1));
  }, function (_a) {
    var _color = _a._color;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      color: ", ";\n      ", ";\n    "], ["\n      color: ", ";\n      ", ";\n    "])), theme.COLOR(_color), theme.FILL(_color));
  }, function (_a) {
    var hasLink = _a.hasLink;
    return hasLink && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      cursor: pointer;\n      &:hover {\n        ", ";\n        color: ", ";\n      }\n    "], ["\n      cursor: pointer;\n      &:hover {\n        ", ";\n        color: ", ";\n      }\n    "])), theme.FILL('link-hover'), theme.COLOR('link-hover'));
  })
});
var IconStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    flex-shrink: 0;\n  "], ["\n    flex-shrink: 0;\n  "])))
});
var ContentStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var LabelStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ValueStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    font-weight: 500;\n  "], ["\n    font-weight: 500;\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Icon: styled(Icon)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), IconStyles),
  Content: styled.div.attrs(cls.attr('content'))(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), ContentStyles),
  Label: styled(CellHeader)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles),
  Value: styled(Content)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), ValueStyles)
};
export var IconTextValue = function (props) {
  var className = props.className,
    children = props.children,
    href = props.href,
    iconComponent = props.iconComponent,
    label = props.label,
    color = props.color,
    iconSize = props.iconSize,
    useIcon = props.useIcon,
    reverse = props.reverse;
  var Link = useLink().Link;
  var t = useLang();
  var hasLink = !!href;
  var Icon = iconComponent ? iconComponent : PersonIcon;
  return React.createElement(Link, {
    style: {
      textDecoration: 'none'
    },
    href: href
  }, React.createElement(My.Container, {
    className: cls.name(className),
    hasLink: hasLink,
    _color: color,
    reverse: reverse
  }, useIcon && React.createElement(My.Icon, {
    size: iconSize
  }, React.createElement(Icon, null)), React.createElement(My.Content, null, React.createElement(My.Label, null, t(label)), React.createElement(My.Value, null, children))));
};
IconTextValue.cls = cls;
IconTextValue.defaultProps = IconTextValueDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13;